declare const jQuery: any;
const $ = jQuery;

import { getCookie, setCookie, deleteCookie } from "./cookies";
import * as classnames from "classnames";

export function initAllPopups(): void
{
	if (window["IW_DISABLE_POPUPS"])
	{
		return;
	}
	$(function ($) {
		initPopups($(`[data-popup]`));
	});
}

export function initAllPopupBtns()
{
	$(`[data-popup-btn]`).click(function (ev) {
		const $btn = $(this);
		const id: string = $btn.attr("data-popup-btn");
		const $popup = $(`[data-popup="${id}"]`).first();
		showPopup($popup);
		return false;
	});
}

function initPopups($popups)
{
	$popups.on("open", function popupOpen() {
		showPopup($(this));
	}).on("close", function popupClose() {
		hidePopup($(this));
	});
	$popups.find(`[data-popup-close]`).click(function (ev) {
		const $popup = $(this).closest(`[data-popup]`);
		hidePopup($popup);
	});
	$popups.filter(`[data-auto-open-delay]`).each(function () {
		const $popup = $(this);
		const popupId: string = $popup.attr("data-popup");
		if (timedPopupWasDismissed(popupId))
		{
			return;
		}
		const delayMSecs: number = (parseInt($popup.attr("data-auto-open-delay"), 10) || 0) * 1000;
		setTimeout(function () {
			showPopup($popup);
		}, delayMSecs);
	}).on("closed", function () {
		// set cookie to remember being dismissed
		const $popup = $(this);
		const popupId: string = $popup.attr("data-popup");
		const cookieName: string = "tpu_dismiss_" + popupId;
		setCookie(cookieName, "1");
	});
}

function timedPopupWasDismissed(popupId: string): boolean
{
	const cookieName: string = "tpu_dismiss_" + popupId;
	return !!getCookie(cookieName);
}

function showPopup($popup): void
{
	$popup.css({ display: "block" }).removeClass("too-tall");
	const $inner = $popup.find(".popup-main").children();
	setTimeout(function () {
		$popup.addClass("show");
		if ($inner.outerHeight() >= $popup.outerHeight())
		{
			$popup.addClass("too-tall");
		}
		$popup.find("[autofocus]").first().focus();
		$popup.trigger("opened");
	}, 40);
}

function hidePopup($popup): void
{
	$popup.removeClass("show").removeClass("too-tall");
	setTimeout(function () {
		$popup.css({ display: "none" }).trigger("closed");
	}, 650);
}

export interface DynamicPopupSettings
{
	content: any; // HTML/jQuery/DOMElement
	popupId?: string;
	className?: string|string[];
	heading?: string;
	putCloseBtn?: boolean; // default true
	autoOpenDelay?: number; // milliseconds before auto-open
}

// Creates a new popup on the fly and appends it to <body>.
// Returns jQuery for popup.
// To open/close it, fire open/close events on the returned jQuery object.
export function createDynamicPopup(settings: DynamicPopupSettings)
{
	const popupId: string = settings.popupId || getDynamicPopupId();
	const $popup = $(`<div>`).attr("data-popup", popupId);
	if (settings.autoOpenDelay)
	{
		$popup.attr("data-auto-open-delay", settings.autoOpenDelay);
	}
	$popup.addClass(classnames("popup", `popup-${popupId}`, settings.className));
	const $main = $(`<div class="popup-main">`).appendTo($popup);
	const $mainInner = $(`<div>`).appendTo($main);
	if (settings.heading)
	{
		$mainInner.append(`<header><h2>${settings.heading}</h2></header>`);
	}
	const $content = $(`<div class="popup-content">`).append(settings.content);
	$mainInner.append($content);
	if (settings.putCloseBtn || settings.putCloseBtn === undefined)
	{
		$popup.append(`<div class="popup-close-wrap"><div class="popup-close" data-popup-close=""></div></div>`);
	}
	$("body").append($popup);
	initPopups($popup);
	return $popup;
}

let dynamicPopupIdCounter = 0;
function getDynamicPopupId(): string
{
	++dynamicPopupIdCounter;
	return `popup_` + dynamicPopupIdCounter;
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].popups = {
	createDynamicPopup
};
